
<template>
  <span>
    <v-icon left>mdi-account-multiple</v-icon>
    <span v-if="team.name == '*'"><v-icon small left style="padding-bottom:0.2em;">mdi-guy-fawkes-mask</v-icon>{{$t('common.wildcard')}}</span>
    <span v-else-if="isDeletedPlayer"><i>{{$t('common.deleted-team')}}</i></span>
    <span v-else>{{displayedName}}</span>
  </span>
</template>

<script>

export default {
  name: "TeamName",
  components: {},
  props: {
    team: {
      type: Object,
      required: true
    },
  },
  computed: {
    isDeletedPlayer: function() {
      return this.team.name && this.team.name.indexOf('$deleted$') === 0
    },
    displayedName: function() {
      return this.team.name
    },
  },
  methods: {
  }
};
</script>

